<template>
    <div>
        <div v-if="!this.getProblemHasBeenAcknowledged">
            <div>
                <label class="typo__label">{{$t('forms.select-method')}}</label>
                <span :class="{ 'invalid is-invalid': v$.acknowledgmentSelected.$error }">
                    <multiselect v-model.trim="v$.acknowledgmentSelected.$model"
                                 track-by="value"
                                 :close-on-select="true"
                                 :show-labels="false"
                                 label="text"
                                 placeholder="Select one"
                                 :options="acknowledgementOptions"
                                 :searchable="false"
                                 :allow-empty="false">
                    </multiselect>
                </span>
                <div class="invalid-feedback" v-if="v$.acknowledgmentSelected.required">{{ $t('Field is required') }}</div>
            </div>

            <b-form-group
                :label="$t('forms.message')"
                label-for="ackComment">
                <b-form-input id="ackComment" :class="{ 'is-invalid': v$.acknowledgementComment.$error }"
                              v-model.trim="v$.acknowledgementComment.$model" placeholder="Commment"></b-form-input>
                <div class="invalid-feedback" v-if="v$.acknowledgementComment.required">{{ $t('Field is required') }}</div>
            </b-form-group>
            <b-form-group
                :description="$t('forms.sticky-description', {obj: 'host'})"
                label-for="sticky">
                <b-form-checkbox
                    id="sticky"
                    v-model="acknowledgementSticky"
                    name="stickyCheckbox"
                >
                    {{ $t('forms.sticky') }}
                </b-form-checkbox>
            </b-form-group>
            <b-form-group
                :description="$t('forms.notify-description', {obj: 'host'})"
                label-for="sticky">
                <b-form-checkbox
                    id="notify"
                    v-model="acknowledgementNotify"
                    name="notifyCheckbox"
                >
                    {{ $t('forms.notify') }}
                </b-form-checkbox>
            </b-form-group>
            <b-button variant="success" class="w-100" v-on:click="sendAcknowledgeCommand">{{ $t('forms.send-command') }}</b-button>
        </div>
        <div v-if="this.getProblemHasBeenAcknowledged">
            <b-form-group>
                <!--<b-form-checkbox
                    id="removeHostServiceAck"
                    v-model="removeServiceAcknowledgement"
                    name="hostServiceAckCheckbox">
                    {{ $t('Remove Service Acknowledgements') }}
                </b-form-checkbox>-->
                {{ $t('action-items.acknowledge-delete-confirm') }}
            </b-form-group>
            <b-button variant="danger" class="w-100" v-on:click="sendRemoveAcknowledgeCommand">{{ $t('action-items.remove-acknowledge') }}</b-button>
        </div>
    </div>
</template>

<script>

import Multiselect from "vue-multiselect";
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { useToast } from "vue-toastification";

export default {
    name: "HostAcknowledge",
    components: {Multiselect},
    data(){
        return {

            acknowledgmentSelected: {
                value: 'hostOnly',
                text: this.$t('hosts.individual')
            },
            acknowledgementOptions: [
                {
                    value: 'hostOnly',
                    text: this.$t('hosts.individual')
                },
                {
                    value: 'hostAndServices',
                    text: this.$t('hosts.including-services')
                }
            ],
            acknowledgementComment: null,
            acknowledgementSticky: false,
            acknowledgementNotify: false,
            removeServiceAcknowledgement: false,
        }
    },
    setup: () => ({ v$: useVuelidate() }),
    props: [
        'hostuuid',
        'hostid',
        'services',
        'problemHasBeenAcknowledged'
    ],
    validations: {
        acknowledgmentSelected: {
            required
        },
        acknowledgementComment: {
            required
        },
    },
    methods: {
        sendRemoveAcknowledgeCommand: function(){
            let externalCommand = {};
            externalCommand.hostId = this.hostid;
            let url = '/hosts/deleteAcknowledgements.json'
            axios.post(url, externalCommand )
                .then(response => {
                    useToast().success(this.$t('Command successfully sent'), {
                        timeout: 7000
                    });
                    this.$emit('refresh', 'acknowledge');
                })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                });
        },

        sendAcknowledgeCommand: async function(){
            this.v$.$touch();
            const isFormCorrect = await this.v$.$validate();
            if(!isFormCorrect){
                return;
            }

            let externalCommand = [{

                command: 'submitHoststateAck',
                hostUuid: this.getUuid,
                sticky: (this.acknowledgementSticky) ? 2 : 0,
                notify: this.acknowledgementNotify,
                author: this.$store.state.user,
                comment: this.acknowledgementComment,
                hostAckType: this.acknowledgmentSelected.value
            }];

           // externalCommand = JSON.stringify(Object.assign({}, externalCommand));
            this.sendCommand(externalCommand);
        },
        sendCommand: function(externalCommand){
            let url = '/hosts/external_commands.json'
            axios.post(url, externalCommand )
                .then(response => {
                    useToast().success(this.$t('Command successfully sent'), {
                        timeout: 7000
                    });
                    this.$emit('refresh', 'acknowledge');
                })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                });
        }
    },
    computed: {
        getUuid: function(){
            return this.hostuuid;
        },
        getServices: function(){
            return this.services;
        },
        getProblemHasBeenAcknowledged: function(){
            return this.problemHasBeenAcknowledged;
        }
    }
}
</script>

<style scoped>

</style>
